"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentStatsSchema = void 0;
exports.parseContentStats = parseContentStats;
const zod_1 = require("zod");
exports.ContentStatsSchema = zod_1.z.object({
  likes_count: zod_1.z.number(),
  dislikes_count: zod_1.z.number(),
  comments_count: zod_1.z.number(),
  shares_count: zod_1.z.number(),
  views_count: zod_1.z.number(),
  rating: zod_1.z.number(),
  bookmarks_count: zod_1.z.number()
});
function parseContentStats(values) {
  return exports.ContentStatsSchema.parse(values);
}
